<template>
  <div>
    <h2>Utwórz nową</h2>
    <app-input name="name" type="text" placeholder="Nazwa organizacji" v-model="form.name" autocomplete="off" required></app-input>
    <small class="form-error" v-if="!form.correct">Nazwa jest za krótka! (min. 3 znaki)</small>
  </div>
</template>

<script>

import Input from "@/components/Input.vue";

export default {
  name: 'join-organizations',
  data() {
    return {
      form: {
        correct: false,
        name: ''
      }
    }
  },
  methods: {
    checkIfNameisFree() {
      return this.form.name.length >= 3
    },
    updateForm() {
      this.form.correct = this.checkIfNameisFree()
      this.$emit('updateForm', this.form)
    }
  },
  watch: {
    form: {
      handler() {
        this.updateForm()
      },
      deep: true
    }
  },
  created() {
    this.updateForm()
  },
  components: {
    appInput: Input
  }
}
</script>

<style lang="scss" scoped>

</style>
